<h4 class="title">User Create </h4>
<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">

      <!-- <div class="col-md-4">
        <h5 class="form-lable">Company Type</h5>
        <p-dropdown [options]="company_type" (onChange)="company_type_select($event.value)" [(ngModel)]="company_types"
            placeholder="Company Type" optionLabel="y" [showClear]="true"></p-dropdown>
     </div>


        <div class="col-md-4" *ngIf="company_title">
            <h5 class="form-lable">Create Bank Name</h5>
            <input type="text" pInputText [(ngModel)]="bankname" name="bankname"  placeholder="Create Bank Name">
        </div>


        <div class="col-md-4" *ngIf="!company_title">
          <h5 class="form-lable">Select Bank Name</h5>
          <p-dropdown [options]="company_name" [(ngModel)]="bankname" name="bankname"
              placeholder="Select Bank Name" optionLabel="y" [showClear]="true"></p-dropdown>
         </div> -->


         <div class="col-md-4">
          <h5 class="form-lable">Designations</h5>
          <select [(ngModel)]="designation" (change)="getdesctype($event)" class="form-control">
            <option value="">Choose</option>
            <option *ngFor="let item of designation_type" [value]="item.y">{{item.y}}</option>
          </select>
          <!-- <p-dropdown [options]="designation_type" [(ngModel)]="designation" name="designation" 
              placeholder="Designations" optionLabel="y" [showClear]="true"></p-dropdown>
              <div style="font-size: 10px;color: red;" *ngIf="designation_empty_check">Please select designation</div> -->
      </div>

      <div class="col-md-4">
        <h5 class="form-lable">Employee Name</h5>
        <input type="text" pInputText [(ngModel)]="name" name="name" placeholder="Employee Name">
        <div style="font-size: 10px;color: red;" *ngIf="emp_name_empty_check">Please enter Employee Name</div>

      </div>


         <div class="col-md-4">
        <h5 class="form-lable">User ID</h5>
        <input type="text" pInputText [(ngModel)]="email_id" name="email_id" placeholder="User ID">
        <div style="font-size: 10px;color: red;" *ngIf="emp_email_empty_check">Please enter User ID</div>

         </div>

    <div class="col-md-4">
      <h5 class="form-lable">Password</h5>
      <input type="text" pInputText [(ngModel)]="password" name="password" placeholder="Password">
      <div style="font-size: 10px;color: red;" *ngIf="emp_password_empty_check">Please enter Password</div>

  </div>

  <div class="col-md-4">
    <h5 class="form-lable">Phone Number</h5>
    <input type="text" pInputText [(ngModel)]="phone_number" name="phone_number"  placeholder="Phone Number">
    <div style="font-size: 10px;color: red;" *ngIf="emp_phone_empty_check">Please enter Phone Number</div>
  </div>

  <div class="col-md-4" *ngIf="fvca">
    <h5 class="form-lable">Field Visit Territory</h5>
    <select class="form-control" [(ngModel)]="fieldvisitterritory">
      <option value="">Choose</option>
      <option *ngFor="let item of areaCodeList" [value]="item.areacode">{{item.areacode}}</option>
    </select>                        
  </div>

  <div class="col-md-4" *ngIf="fvca">
    <h5 class="form-lable">Field Visit Area</h5>
    <select class="form-control" [(ngModel)]="fieldvisitarea">
      <option value="">Choose</option>
      <option *ngFor="let item of fieldvisitCodeList" [value]="item.fvcode">{{item.fvcode}}</option>
    </select>                                               
  </div>

  <br>

  <div class="col-md-12" style="margin-top: 25px;">
    <div class="row">
      <div class="col-md-12">
        <h3><strong>Side Menu Access</strong></h3>
      </div>
    </div>
    <div class="row">

      <ng-container *ngFor="let item of menu_details; let i = index">
        <div class="col-md-1">
          <input type="checkbox" (change)="changeStatus(i,$event.target.checked)" [(ngModel)]="item.Status">
        </div>
        <div class="col-md-2">
          <label for="vehicle1">{{item.title}}</label>
        </div>
      </ng-container>
    </div>
  </div>


  <div class="col-md-12" style="margin-top: 25px;">
    <div class="row">
      <div class="col-md-12">
        <h3><strong>Select Portfolio</strong></h3>
        <div class="col-md-4">


          <ng-multiselect-dropdown
          name="city"
          [data]="cities"
          [(ngModel)]="selectedItem"
          [settings]="dropdownSettings"
          (onSelect)="onItemSelect($event)"
          [disabled]="disabled">
          </ng-multiselect-dropdown>



        <!-- <select (change)="getdesctype1($event)" class="form-control">
          <option value="">Choose</option>
          <option *ngFor="let item of portfolio_list" [value]="item._id">({{item.bank_id.bank_name}}) ,<br> {{item.portfolio_type}}</option>
        </select> -->
      </div>
      <div class="col-md-4">
        <button  class="btn btn-primary" (click)="addportfolio()">Add</button>
      </div>
      <div class="col-md-4">
        <button  class="btn btn-primary" (click)="selectall()">Select All</button>
        <button  class="btn btn-primary" (click)="deleteall()">Delete All</button>

      </div>
      </div>
    </div>
    <br>
    <div class="row" style="padding: 20px;">
      <ng-container *ngFor="let item of selected_portfolio_list; let i = index">
        <div class="col-md-3" style="border: 1px solid;padding: 5px;">
        <div class="col-md-3">
          <button  class="btn btn-danger" (click)="deleteportfolio(i)"><i class="fa fa-trash"></i></button>
        </div>
        <div class="col-md-9">
          <label for="vehicle1" style="margin-top: 8px;">Bank : {{item.bank_id.bank_name}} <br> Portfolio : {{item.portfolio_type}} </label>
        </div>
       </div>
      </ng-container>
    </div>
  </div>


  <div class="col-md-12">
  <div class="row">
    <div class="col-md-12 mt-20">
      <button *ngIf="edit_f == false" type="button" class="btn btn-primary" (click)="Condition_check_add()">Add</button>
      <button  *ngIf="edit_f == true" type="button" class="btn btn-primary" (click)="edit()">Update</button>
      <button type="button" *ngIf="edit_f == true" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button>
     </div>
  </div>
  </div>


    </div>
</div>




<div class="row">
    <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div>
    <!-- <div class="col-md-8 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="doc_form()">Add</button>
    </div> -->
</div>
<div class="doc-table">

    <div class="card-box">
       <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="25"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">

        <ng-template pTemplate="header">
            <tr class="thhead">
                <th class="th-1">S.No</th>
                <!-- <th>Bank Name</th> -->
                <th>Designations</th>
                <th>User Name</th>
                <th>User Id</th>
                <th>Password</th>
                <th>Phone Number</th>
                <!-- <th>Side Menu Access</th> -->
                <th>Status</th>
                <th>Create by</th>
                <th>Create at</th>
                <th style="width: 110px;text-align:center">
                    Action
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="tdrow">
                <td>{{i+1}}</td>
            <!-- <td>{{item.bankname}}</td> -->
            <td>{{item.designation}}</td>
            <td>{{item.name}}</td>
            <td>{{item.email_id}}</td>
            <td>{{item.password}}</td>
            <td>{{item.phone_number}}</td>
            <!-- <td>
              <ng-container *ngFor="let accessitem of item.access;">
              <div *ngIf="accessitem.Status">{{accessitem.title}},</div>
              </ng-container>
            </td> -->
            <td>{{item.status}}</td>
            <td>{{item.created_by}}</td>
            <td>{{item.createdAt | date}}</td>
            <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit" (click)="show_edit(item)" ></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="delete(item._id)" ></i>
            </td>
            </tr>
        </ng-template>
     </p-table>  </div>

</div>
